import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Headphones } from "lucide-react";
import { LISTEN, BRAND } from "../data/content";
import BrandIcon from "./BrandIcons";

// Floating LISTEN button + integrated mini-panel (Spotify / Apple Music).
export default function ListenDock() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 z-[9200]">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 16, scale: 0.94 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.94 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="absolute bottom-16 right-0 w-64 glass-strong rounded-sm p-4 overflow-hidden"
            data-testid="listen-panel"
          >
            <div className="flex items-center justify-between mb-4">
              <p className="track-label text-white/50">LISTEN</p>
              <span className="font-display chrome-text text-sm">{BRAND.name}</span>
            </div>
            <div className="flex flex-col gap-2">
              {LISTEN.map((l) => (
                <a
                  key={l.key}
                  href={l.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`listen-panel-${l.key}`}
                  className="flex items-center gap-3 px-4 py-3 border border-white/12 hover:border-white hover:bg-white hover:text-black transition-all duration-300 group"
                >
                  <BrandIcon name={l.icon} size={20} />
                  <span className="font-body text-sm">{l.label}</span>
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        onClick={() => setOpen((v) => !v)}
        data-testid="listen-dock-toggle"
        data-cursor
        whileTap={{ scale: 0.94 }}
        className="flex items-center gap-2 glass-strong rounded-full pl-4 pr-5 py-3 text-white hover:bg-white hover:text-black transition-colors duration-300 shadow-[0_10px_40px_rgba(0,0,0,0.5)]"
        aria-label="Listen"
      >
        {open ? <X size={16} /> : <Headphones size={16} />}
        <span className="track-label">LISTEN</span>
      </motion.button>
    </div>
  );
}
